import React from 'react';
import Radium from 'radium';
import { connect } from 'react-redux';
import StyleDecorator from '../../components/StyleDecorator';
import smallBackgroundImage from '../../static/images/login-bg-image-small.jpg';
import logoImage from '../../static/images/sipgate-brandmark-white.svg';
import Theme from '../../styles/theme';

class SipgateFormHeaderLogo extends React.Component {

	static propTypes = {
		mediaQueries: React.PropTypes.object,
	};

	getStyle() {
		const MediaQueries = this.props.mediaQueries;

		return {
			header: {
				width: '100%',
				textAlign: 'center',
				backgroundSize: 'cover',
				backgroundImage: (MediaQueries.isMinMediumDevice()) ? '' : 'url(' + smallBackgroundImage + ')',
				backgroundColor: Theme.palette.primary1Color,
				backgroundPosition: 'center center',
				backgroundRepeat: 'no-repeat',
			},
			headerLogo: {
				width: '200px',
				paddingTop: '70px',
				paddingBottom: '60px',
			},
		};
	}

	render() {
		const style = this.getStyle();
		return (
			<div style={style.header}>
				<img
					alt={'sipgate Logo'}
					style={style.headerLogo}
					src={logoImage}
				/>
			</div>
		);
	}
}
export default connect()(StyleDecorator(Radium(SipgateFormHeaderLogo)));



// WEBPACK FOOTER //
// ./src/components/images/SipgateFormHeaderLogo.js